<template>
  <div ref="appContainer" class="app-container">
    <!-- 控制面板 -->
    <div style="margin-left:30px;">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-switch
              v-model="horizontal"
              :width="50"
              active-text="横排"
              inactive-text="竖排"
              style="margin-top:8px;"
          />
        </el-col>
        <el-col :span="5">
          <el-switch
              v-model="expandAll"
              :width="50"
              active-text="全部展开"
              inactive-text="全部折叠"
              style="margin:8px;"
              @change="expandChange"
          />
        </el-col>
        <el-col :span="14">
          <span style="font-size:14px;font-weight:500;">选择背景色:</span>
          <el-select v-model="labelClassName" @change="selectChange">
            <el-option value="bg-white" label="白色">白色</el-option>
            <el-option value="bg-orange" label="橘黄色">橘黄色</el-option>
            <el-option value="bg-gold" label="金色">金色</el-option>
            <el-option value="bg-gray" label="灰色">灰色</el-option>
            <el-option value="bg-lightpink" label="浅粉色">浅粉色</el-option>
            <el-option value="bg-chocolate" label="巧克力色">巧克力色</el-option>
            <el-option value="bg-tomato" label="番茄色">番茄色</el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>

    <!-- 树形结构 -->
    <div style="font-size:12px;margin-top:30px;">
      <org-tree
          v-if="treeData.data"
          :data="treeData.data"
          :horizontal="!horizontal"
          :collapsable="collapsable"
          :label-class-name="labelClassName"
          :render-content="renderContent"
          name="organ"
          @on-node-click="onNodeClick"
      ></org-tree>
    </div>
  </div>
</template>

<script>
const data = [
  {
    "IDSEQ": 463624,
    "STFG": "N",
    "FINDTTM": "2025-10-29",
    "OUTPUT": "功能表单",
    "ADDUSER": "彭建武",
    "EMPNM2": "刘思维",
    "ITEMTY": "功能界面编写",
    "WKTY": "系统功能开发",
    "CODE": "96231",
    "ADDDTTM": "2025-10-25 13:46:23",
    "PARENTNO": "#",
    "LSTSEQ": 96231,
    "WKNM": "画板",
    "RN": 1
  },
  {
    "IDSEQ": 463624,
    "STFG": "N",
    "FINDTTM": "2025-11-11",
    "SRC": "绘图软件",
    "OUTPUT": "PCBA图纸",
    "ADDUSER": "彭建武",
    "EMPNM2": "梁秀娟",
    "ITEMTY": "PCB板画图",
    "WKTY": "线路板",
    "CODE": "98875",
    "ADDDTTM": "2025-11-01 18:34:13",
    "PARENTNO": "96228",
    "LSTSEQ": 98875,
    "WKNM": "检验",
    "RN": 2
  },
  {
    "IDSEQ": 463624,
    "STFG": "N",
    "FINDTTM": "2025-11-28",
    "SRC": "测试仪",
    "OUTPUT": "温度测试结果",
    "ADDUSER": "彭建武",
    "EMPNM2": "李小红",
    "ITEMTY": "温升测试",
    "WKTY": "线路板",
    "CODE": "98806",
    "ADDDTTM": "2025-11-01 11:22:26",
    "PARENTNO": "96231",
    "LSTSEQ": 98806,
    "WKNM": "测试",
    "RN": 3
  },
  {
    "IDSEQ": 463624,
    "STFG": "N",
    "FINDTTM": "2025-10-26",
    "SRC": "绘图软件",
    "OUTPUT": "PCBA图纸",
    "ADDUSER": "彭建武",
    "EMPNM2": "刘建邦",
    "ITEMTY": "PCB板画图",
    "WKTY": "线路板",
    "CODE": "96228",
    "ADDDTTM": "2025-10-25 13:43:53",
    "PARENTNO": "#",
    "LSTSEQ": 96228,
    "WKNM": "采购线路板",
    "RN": 4
  },
  {
    "IDSEQ": 463624,
    "STFG": "N",
    "FINDTTM": "2025-10-29",
    "SRC": "上位机",
    "OUTPUT": "测试报告",
    "ADDUSER": "彭建武",
    "EMPNM2": "梁秀娟",
    "ITEMTY": "电机平稳度测试",
    "WKTY": "线路板",
    "CODE": "96229",
    "ADDDTTM": "2025-10-25 13:44:46",
    "PARENTNO": "96228",
    "LSTSEQ": 96229,
    "WKNM": "入仓",
    "RN": 5
  },
  {
    "IDSEQ": 463624,
    "STFG": "N",
    "FINDTTM": "2025-11-26",
    "SRC": "技术采购费用",
    "OUTPUT": "PCBA图纸",
    "ADDUSER": "彭建武",
    "EMPNM2": "董晓明",
    "ITEMTY": "PCB板画图",
    "WKTY": "线路板",
    "CODE": "98868",
    "ADDDTTM": "2025-11-01 18:30:11",
    "PARENTNO": "#",
    "LSTSEQ": 98868,
    "WKNM": "插件测试",
    "RN": 6
  }
]

export default {
  name: "check_wait",
  data() {
    return {
      treeData: { data: null },
      horizontal: true,
      collapsable: false,
      expandAll: true,
      labelClassName: '#808695',
 
    }
  },
  mounted() {
    this.treeData.data = this.buildTree(data)
  },
  methods: {
    // --- 生成树结构 ---
    buildTree(list) {
      const map = {}
      list.forEach(item => {
        map[item.CODE] = {
          id: item.CODE,
          label: item.WKNM,  // 工序名
          EMPNM2: item.EMPNM2 || '', // 负责人
          children: []
        }
      })

      const roots = []

      list.forEach(item => {
        if (item.PARENTNO && item.PARENTNO !== '#') {
          const parent = map[item.PARENTNO]
          if (parent) {
            parent.children.push(map[item.CODE])
          } else {
            roots.push(map[item.CODE])
          }
        } else {
          roots.push(map[item.CODE])
        }
      })

      return {
        id: '1',
        label: '项目进度',
        EMPNM2: '',
        children: roots
      }
    },

    // --- 自定义节点渲染 ---
    renderContent(h, data) {
      // 判断负责人是否为刘思维
      const isTarget = data.EMPNM2 === '刘思维'

      const style = {
        backgroundColor: isTarget ? '#007bff' : '', // 蓝色背景
       
        color: isTarget ? '#fff' : '',
        padding: '4px 6px',
        //border:'1px solid red',
        display: 'inline-block'
      }

      return (
          <div style={style}>
            <span>{data.label}</span>
            {data.EMPNM2 ? <span style="margin-left: 6px;">（{data.EMPNM2}）</span> : ''}
          </div>
      )
    },

    // --- 点击事件 ---
    onNodeClick(e, data) {
      this.$message(`点击了节点：${data.label}`)
    },

    // --- 展开收起控制 ---
    toggleExpand(data, val) {
      if (Array.isArray(data)) {
        data.forEach(item => {
          this.$set(item, "expand", val)
          if (item.children) this.toggleExpand(item.children, val)
        })
      } else {
        this.$set(data, "expand", val)
        if (data.children) this.toggleExpand(data.children, val)
      }
    },
    expandChange() {
      this.collapsable = true
      this.toggleExpand(this.treeData.data, this.expandAll)
    },
    selectChange() {}
  }
}
</script>

<style scoped lang="less">

 
.el-org-tree {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .org-tree-node-label {
    white-space: nowrap;
 
  }
  /deep/ .org-tree-node-label .org-tree-node-label-inner {
    padding: 0 !important;
    cursor: pointer;
    border-radius:6px;
 
  }
}
/deep/ .el-org-tree {.org-tree-node-label-inner{
  padding: 0 !important;
  border-radius:10px;
 
}}
:deep(.org-tree-node-label-inner) {
  padding: 0 !important;
 
}
</style>